import { createApp } from "vue";
import PhosphorIcons from "@phosphor-icons/vue";
import App from "./App.vue";
import router from "./router";
import "./assets/style.css";
import "./registerServiceWorker";
import { MotionPlugin } from "@vueuse/motion";
import store from "./store";

createApp(App)
  .use(store)
  .use(MotionPlugin)
  .use(PhosphorIcons)
  .use(router)
  .mount("#app");
